module.exports = __webpack_public_path__ + "static/media/ic_checkmark.1bece322.svg";